<template>
  <div class="ma-4">
        <Sidebar />
        <v-row class="pl-14">
          <v-col cols="12" v-if="showPayrollFeature">
            <Default v-if="defaultPage" />
            <RHSPayroll v-if="rhsPayroll && userCompanies.includes('64a29e0cd378e000143694dd')" />
            <Scheduled v-if="scheduledPage" />
            <Outstanding v-if="outstandingPage" />
            <Settings v-if="settingsPage" />
          </v-col>
          <v-col cols="12" v-if="!showPayrollFeature">
            <v-alert
              border="bottom"
              color="pink darken-1"
              dark
            >
              You Don't Have Permission To Access This Page.
            </v-alert>
          </v-col>
        </v-row>
  </div>
</template>

<script>
  import axios from 'axios';
  const url = require("../client_config/config").url;

  import { mapState } from "vuex";
  import Sidebar from "../components/payroll/Sidebar";
  import RHSPayroll from "../components/payroll/pages/RHS-Payroll";
  import Default from "../components/payroll/pages/Index";
  import Scheduled from "../components/payroll/pages/Schedule";
  import Outstanding from "../components/payroll/pages/Outstanding";
  import Settings from "../components/payroll/pages/Settings";
  export default {
    components: {
      RHSPayroll,
      Default,
      Sidebar,
      Scheduled,
      Outstanding,
      Settings
    },

    data: () => ({
      settings: [],
      userRole: localStorage.getItem("userRole"),
      userCompanies: JSON.parse(localStorage.getItem("userCompanies")),
      showPayrollFeature: true,
    }),


    computed: {
      ...mapState({
        rhsPayroll: state => state.payroll.rhsPayroll,
        defaultPage: state => state.payroll.defaultPage,
        scheduledPage: state => state.payroll.scheduledPage,
        outstandingPage: state => state.payroll.outstandingPage,
        settingsPage: state => state.payroll.settingsPage,
      }),
    },

    created(){
      this.getSettings();
    },

    methods: {
      async getSettings(){
        await axios.get(`${url}/payroll/settings`).then(res => {
          this.settings = res.data.Roles;
          //console.log(this.settings)
          if(this.settings.includes(this.userRole)){
            this.showPayrollFeature = true;
          }else{
            this.showPayrollFeature = false;
          }

          if(this.userRole === "Administration" ||
            this.userRole == 'Human Resources' ||
            this.userRole == 'Compliance Manager' ||
            this.userRole == 'Program Coordinator' ||
            this.userRole == 'Executive Director'){
            this.showPayrollFeature = true;
          }

        });
      }
    }
  }

</script>
